// import Vue from 'vue'
import axios from 'axios';


let api = {
    auth: null
}

api.addHttpRequestInterceptor = (interceptor, onerrorCallback) => {
    window.api.axios.interceptors.request.use(interceptor, function(err) {
        if(onerrorCallback) onerrorCallback(err)
        return Promise.reject(err);
    });
}

api.addHttpResponseInterceptor = (interceptor, onerrorCallback) => {
    window.api.axios.interceptors.response.use(interceptor, function(err) {
        if(onerrorCallback) onerrorCallback(err)
        return Promise.reject(err);
    });
}

api.getFormIDFromURL = () => {
    const url = new URL(window.location)
    const queryParam = url.searchParams.get('id')

    if (queryParam) return queryParam

    // Hash routes use #/<form-id>. Do not coerce the value to a number:
    // form identifiers can also be slugs (for example, "ehu-reserva-espacios-form").
    const hashPath = url.hash.slice(1).split('?')[0]
    const hashSegments = hashPath.split('/').filter(Boolean)
    const hashParam = hashSegments.pop()

    if (hashParam) return decodeURIComponent(hashParam)

    // Keep supporting the existing numeric path-based URLs.
    return +url.pathname.split('/').filter(Boolean).pop() || 0
}

api.setAuth = (auth) => {
    window.console.log('setAuth:', auth)
    api.auth = auth
}

api.addErrorHandler = (r) => {

    // window.api.clearValidationErrors();
    r.catch(excep => {
        window.api.clearValidationErrors();

        window.console.log('addErrorHandler::catch>', excep);
        // eval('debugger')
        let msg = 'Error invocando el servicio'
        let description = ''

        if (typeof excep === 'string') description = excep;
        else if (excep.message && excep.stack) {
            window.api.getContext().validationErrors.push({ msg: excep.message, description:  excep.stack })
        } else {
            // eval('debugger')
            window.console.log('excep>', excep)
            let er = (excep || {}).response;
            let status = er.status;
            let statusText = er.statusText;
            let url = (er.config || {}).url;
            let method = (er.config || {}).method;
            if(method) method = method.toUpperCase() + ' ';

            let d = (excep.response.data || {});

            let error = d.error || '';
            window.console.table('err error>', error)
            let dmessage = d.message || '';
            description = (d.error ||{}).description || description
            url = d.path || url

            let addDetails = (ce) => {
                return `
                <p class="validation-message-description">
                    <strong> ID Error:</strong> ${ce.id} <br/> <br/>
                    <strong> Descripción:</strong> <br/>
                    ${ce.description}<br/> <br/>
                    <strong> Causa:</strong>
                    <br/> ${ce.causa || ''}
                </p>`
            }

            if (d.error && d.error.causa && d.error.causa.error && d.error.causa.error.id) {
                let ce = d.error.causa.error
                dmessage = dmessage + addDetails(ce)
            }

            try {
                var enc = new TextDecoder("utf-8");
                window.console.log('en httpbaseerror')
                let s = (enc.decode((excep.response || {}).data));
                let jsonERR = JSON.parse(s).error
                window.console.table(jsonERR)
                dmessage = dmessage + addDetails(jsonERR)
                window.console.log('here')
            } catch (e2) {
                window.console.log('no hay cuerpo')
            }

            if (error.id) {
                dmessage = dmessage + addDetails(error)
            }

            msg = 'HTTP/' + status + ' - ' + statusText
            description = 'Error invocando el servicio en ' + url + "." + (error.description || error) + '.' + dmessage;

            // window.api.clearValidationErrors();
            window.api.getContext().validationErrors.push({ msg, description })
        }


    })
    return r
}

api.GET = function (url) {
    let r = window.api.axios.get(url, {
        auth: this.auth
    })

    return api.addErrorHandler(r)
}

api.POST = function (url, objectToPost, headers) {
    let h = Object.assign(headers || {}, { auth: this.auth })
    window.console.log('POST>', h)
    let r = window.api.axios.post(url, objectToPost, h)

    return api.addErrorHandler(r)
}

api.POSTWithHeaders = function (url, objectToPost, headers) {
    let h = Object.assign(headers || {}, { auth: this.auth })
    window.console.log('POST>', h)
    let r = window.api.axios.post(url, objectToPost, { headers })

    return api.addErrorHandler(r)
}


api.MultipartPUT = async (url, data) => {
    let promise = window.api.axios.put(url, data, {
        auth: api.auth,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })

    return api.addErrorHandler(promise);
}

api.MultipartPOST = async (url, data /*, opts */) => {
    /*
    const headers = {
        'Content-Type': 'multipart/form-data'
    }
    if (opts) {
        const {username, password, bearer_token} = opts
        if (bearer_token)
            headers.Authorization = `${bearer_token}`

        if (username || password)
            headers.Authorization = btoa( `${username || ''}:${password || ''}`)
    }
        */

    let promise = window.api.axios.post(url, data)

    return api.addErrorHandler(promise);
}


axios.interceptors.request.use(config => {
    if (!config.headers["x-request-id"]) {
        config.headers["x-request-id"] = window.api.generateUUID()
    }

    return config;
});
api.axios = axios;

export default api;
